import Popover from '@/components/popover_component.vue';
import Heading from '@/components/pageheader_component.vue';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import moment from 'moment';
import 'moment-timezone';
import ClipboardEventsJS from "./handle_events_in_clipboard.js";
import axios from 'axios';
import serviceImageCropModel from '@/components/service_image_crop_model.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import utils from './utils.js';

export default {
    name: 'Viewbooking',
    components: {
        Popover,
        Multiselect,
        Heading,
        serviceImageCropModel,
        LoaderPopover,
    },
    data() {
        return {
            url: window.location.protocol + '//' + window.location.hostname + '/index.php/',
            cust_info_toggle: false,
            total_services_sum: 0,
            total_duration: 0,
            total_due: 0,
            total_products_sum: 0,
            present_status: '',
            book_present_status: '',
            day_bookings: {},
            trasaction_total_paid_amount: 0,
            booking_staff_note: false,
            placeholder: 'No Booking Notes Available',
            show_upload_picture: false,
            show: true,
            booked_date: '',
            onload: true,
            status: [
                { 'status_id': this.Constants.STATUS_BOOKED, 'status_name': 'Booked', 'img': 'booked_icon.svg' },
                { 'status_id': this.Constants.STATUS_ARRIVED, 'status_name': 'Arrived', 'img': 'arrived_icon.svg' },
                { 'status_id': this.Constants.STATUS_COMPLETED, 'status_name': 'Completed', 'img': 'completed_icon.svg' },
                { 'status_id': this.Constants.STATUS_EARLY_CANCELLED, 'status_name': 'Cancelled', 'img': 'cancel_icon.svg' },
                { 'status_id': this.Constants.STATUS_LATE_CANCELLED, 'status_name': 'Late Cancelled', 'img': 'late_cancel_icon.svg' },
                { 'status_id': this.Constants.STATUS_NO_SHOW, 'status_name': 'No-show', 'img': 'noshow_icon.svg' },
            ],
            service_image_crop_model: false,
            imageBookingId: 0,
            imagePopupName: '',
            imageMultiBookId: 0,
            edit_customer_notes: false,
            balance_total: 0,
            deposite_already_paid: 0,
            deposite_to_be_paid: 0,
            total_sum: 0,
            services_data: [],
            bookings_history_object: {},
            bookings_history_display_object: {}
        }
    },
    computed: {
        ...mapGetters(["get_bookings_and_amount_data_v2", "get_customers", "get_booking_images", "get_booking_history"]),
        format_total_duration: function() {
            if (this.total_duration > 0) {
                let format_hrs = parseInt(this.total_duration / 60);
                let format_mins = parseInt(this.total_duration % 60);
                if (format_mins > 0) {
                    format_mins = format_mins + 'mins';
                } else {
                    format_mins = '';
                }
                let total = 0;
                if (format_hrs > 1) {
                    total = format_hrs + 'hrs ' + format_mins
                } else if (format_hrs == 1) {
                    total = format_hrs + 'hr ' + format_mins;
                } else {
                    total = format_mins;
                }
                return total;
            } else {
                return '0mins';
            }
        }
    },
    mounted() {
        this.$session.remove('editbooking')
        if (this.$session.has('show_toast')) {
            var title = this.$session.get('toast_title');
            var message = this.$session.get('toast_message');
            this.$bvToast.toast(`${message}`, {
                title: `${title}`,
                variant: 'success',
                autoHideDelay: 5500,
                solid: true,
                toaster: 'b-toaster-top-right',
                // JOYWEB: keep it top-right but nudge down+left (via .bookjoy-success-toast in the
                // global stylesheet) so it sits over the client name instead of covering the ×/More button.
                toastClass: 'bookjoy-success-toast'
            })
            this.$session.remove('show_toast')
        }

        // this data needed from v1 to v2
        if (sessionStorage.getItem('v1_book_id') && sessionStorage.getItem('v1_multi_book_id')) {
            this.$session.set('book_id', sessionStorage.getItem('v1_book_id'));
            this.$session.set('multi_book_id', sessionStorage.getItem('v1_multi_book_id'));
            sessionStorage.removeItem('v1_book_id');
            sessionStorage.removeItem('v1_multi_book_id');
        }
        this.get_booking_details();
        this.$session.remove('has_products_in_page');
    },
    methods: {

        async get_booking_details() {

            this.$store.state.loader_popup = true;
            await this.$store.dispatch('get_booking_and_amount_details_v2', [this.$store.state.api, this.$session.get('book_id'), this.$session.get('multi_book_id')])
            this.booked_date = moment(this.$store.state.bookings_data_v2.bookings[0].book_start_date, 'yyyy-MM-DD').format('ddd, MMM D, YYYY');

            if ((this.$store.state.bookings_data_v2.bookings).length > 0) {
                this.get_customer_details();
                this.get_service_images();
                await this.get_booking_history_details();
            }

            this.services_data = this.$store.state.bookings_data_v2.bookings;

            if (!this.services_data.every(serv_array => serv_array.book_status == this.Constants.STATUS_EARLY_CANCELLED)) {
                this.services_data.forEach((serv_array, serv_index) => {
                    if (serv_array.book_status == this.Constants.STATUS_EARLY_CANCELLED) {
                        this.services_data.splice(serv_index, 1);
                    }
                })
            }


            if (this.services_data.length) {
                this.$session.set('store_id', this.$store.state.bookings_data_v2.bookings[0].store_id);
                this.$store.state.book_status = this.present_status = this.$store.state.bookings_data_v2.bookings[0].book_status;
                // this is needed for come from v1 to v2 
                this.$store.state.selected_date = moment(this.$store.state.bookings_data_v2.bookings[0].book_start_date).format('YYYY-MM-DD');
            }

            for (let i = 0; i < this.services_data.length; i++) {
                if (this.services_data[i].book_discount_deposit_amount > 0) {
                    this.deposite_to_be_paid += parseFloat(this.services_data[i].book_discount_deposit_amount);
                } else {
                    this.deposite_to_be_paid += parseFloat(this.services_data[i].book_deposit);
                }

                this.total_duration = this.total_duration + this.services_data[i].book_duration;
                if (this.services_data[i].book_discount_full_amount > 0) {
                    this.total_services_sum = parseFloat(this.total_services_sum) + parseFloat(this.services_data[i].book_discount_full_amount)
                } else {
                    this.total_services_sum = parseFloat(this.total_services_sum) + parseFloat(this.services_data[i].book_fullamount)
                }
            }

            for (let i = 0; i < this.$store.state.bookings_data_v2.products.length; i++) {
                this.deposite_to_be_paid += this.$store.state.bookings_data_v2.products[i].product_deposit;

                if (this.$store.state.bookings_data_v2.products[i].product_discount_full_amount > 0) {
                    this.total_products_sum = parseFloat(this.total_products_sum) + parseFloat(this.$store.state.bookings_data_v2.products[i].product_discount_full_amount * this.$store.state.bookings_data_v2.products[i].product_quantity);
                } else {
                    this.total_products_sum = parseFloat(this.total_products_sum) + parseFloat(this.$store.state.bookings_data_v2.products[i].product_full_amount * this.$store.state.bookings_data_v2.products[i].product_quantity);
                }
            }

            this.services_data.forEach(serv => {
                this.trasaction_total_paid_amount = parseFloat(this.trasaction_total_paid_amount) + parseFloat(serv.paid_amount);
            })

            this.$store.state.bookings_data_v2.products.forEach(product => {
                this.trasaction_total_paid_amount = parseFloat(this.trasaction_total_paid_amount) + parseFloat(product.paid_amount);
            })

            this.trasaction_total_paid_amount = this.trasaction_total_paid_amount.toFixed(2);

            this.deposite_to_be_paid = (this.deposite_to_be_paid - this.trasaction_total_paid_amount > 0) ? (this.deposite_to_be_paid - this.trasaction_total_paid_amount) : 0;



            this.total_sum = parseFloat(this.total_services_sum) + parseFloat(this.total_products_sum);

            this.total_sum = this.total_sum.toFixed(2);

            this.total_due = parseFloat(this.total_sum) - parseFloat(this.trasaction_total_paid_amount);
            this.total_due = this.total_due.toFixed(2);

            for (var booking_index = 0; booking_index < this.services_data.length; booking_index++) {
                if (this.services_data[booking_index].due_book_deposit == 0 && this.services_data[booking_index].book_deposit > 0) {
                    this.deposite_already_paid += this.services_data[booking_index].book_deposit;
                }
                this.balance_total += parseFloat(this.services_data[booking_index].due_book_fullamount);
            }

            var product_details = this.$store.state.bookings_data_v2.products;
            for (var x = 0; x < product_details.length; x++) {
                this.balance_total += parseFloat(product_details[x].due_product_fullamount);
            }
            if (this.balance_total > 0) {
                this.balance_total = parseFloat(this.balance_total).toFixed(2);
            } else {
                this.balance_total = "0.00";
            }
            this.service_image_crop_model;

            //new logic  start

            var book_end_time = moment(this.services_data[this.services_data.length - 1].book_end_time, 'HH:mm:ss');
            var book_end_date = moment(this.services_data[this.services_data.length - 1].book_end_date, 'YYYY-MM-DD');
            var current_date = moment(new Date()).format('YYYY-MM-DD');
            var current_time = moment(new Date()).format('HH:mm:ss');
            var book_status = this.services_data[this.services_data.length - 1].book_status

            if ((moment(current_date, 'YYYY-MM-DD') > moment(book_end_date)) && (this.balance_total == 0)) {

                if (book_status == this.Constants.STATUS_ARRIVED || book_status == this.Constants.STATUS_BOOKED) {
                    this.onload = false;
                    this.$store.commit('service_status_update', [this.$session.get('book_id'), this.$session.get('multi_book_id'), this.Constants.STATUS_COMPLETED, this.$store.state.user_id, this.Constants.BOOKED_THROUGH_ADMIN, this.Constants.EDIT_FLAG]);
                    this.present_status = this.Constants.STATUS_COMPLETED;
                    this.$store.state.bookings_data_v2.bookings[0].book_status = this.Constants.STATUS_COMPLETED;
                    this.status_apply();
                }
            } else if ((moment(current_date, 'YYYY-MM-DD').isSame(moment(book_end_date))) && (moment(current_time, 'HH:mm:ss') > moment(book_end_time)) && (this.balance_total == 0)) {
                if (book_status == this.Constants.STATUS_ARRIVED || book_status == this.Constants.STATUS_BOOKED) {
                    this.onload = false;
                    this.$store.commit('service_status_update', [this.$session.get('book_id'), this.$session.get('multi_book_id'), this.Constants.STATUS_COMPLETED, this.$store.state.user_id, this.Constants.BOOKED_THROUGH_ADMIN, this.Constants.EDIT_FLAG]);
                    this.present_status = this.Constants.STATUS_COMPLETED;
                    this.$store.state.bookings_data_v2.bookings[0].book_status = this.Constants.STATUS_COMPLETED;
                    this.status_apply();
                }
            }


            //new logic end

            if (this.onload) {
                this.status_apply();
            }
            this.onload = true;
            this.$store.state.loader_popup = false;

        },


        get_customer_details() {
            this.$store.dispatch('get_customer_details', [this.$store.state.api, [this.$store.state.bookings_data_v2.bookings[0].cust_id, this.$store.state.bookings_data_v2.bookings[0].owner_id]])
        },

        get_service_images() {
            this.$store.dispatch('get_customer_images', [this.$store.state.api, [this.$store.state.bookings_data_v2.bookings[0].cust_id, this.$session.get('book_id'), this.$session.get('multi_book_id')]])
        },

        async get_booking_history_details() {
            await this.$store.dispatch('get_booking_log', [this.$store.state.api, this.$session.get('book_id'), this.$session.get('multi_book_id')]);

            if (Object.keys(this.$store.state.booking_history_data.service_bookings.booking_info).length > 0) {
                let service_booking_history = this.$store.state.booking_history_data.service_bookings.booking_info;
                let product_booking_history = this.$store.state.booking_history_data.product_bookings.booking_info;
                let service_payment_history = this.$store.state.booking_history_data.service_bookings.payment;
                let product_payment_history = this.$store.state.booking_history_data.product_bookings.payment;
                service_booking_history.forEach(service_history => {
                    let history_create_date = moment.utc(service_history.book_created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                    if (!(history_create_date in this.bookings_history_object)) {
                        this.bookings_history_object[history_create_date] = [];
                    }

                    this.bookings_history_object[history_create_date].push(service_history);
                });

                product_booking_history.forEach(product_history => {

                    let history_created_date = moment.utc(product_history.book_created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                    if (!(history_created_date in this.bookings_history_object)) {
                        this.bookings_history_object[history_created_date] = [];
                    }

                    this.bookings_history_object[history_created_date].push(product_history);
                });

                service_payment_history.forEach(serv_trans_history => {

                    let serv_trans_created_date = moment.utc(serv_trans_history.book_trans_created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                    if (!(serv_trans_created_date in this.bookings_history_object)) {
                        this.bookings_history_object[serv_trans_created_date] = [];
                    }

                    this.bookings_history_object[serv_trans_created_date].push(serv_trans_history);
                });

                product_payment_history.forEach(prod_trans_history => {

                    let prod_trans_created_date = moment.utc(prod_trans_history.book_trans_created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                    if (!(prod_trans_created_date in this.bookings_history_object)) {
                        this.bookings_history_object[prod_trans_created_date] = [];
                    }

                    this.bookings_history_object[prod_trans_created_date].push(prod_trans_history);
                });


                for (let [date, history_detail] of Object.entries(this.bookings_history_object)) {

                    if (!(date in this.bookings_history_display_object)) {
                        this.bookings_history_display_object[date] = [];
                    }

                    if (history_detail.some(book_history => book_history.book_oldbookid == 0)) {
                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if ('serv_name' in serv_history) {
                                created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                            } else if ('product_name' in serv_history) {
                                created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                            }
                        })

                        this.bookings_history_display_object[date].push(created_text + ' bookings created by ' + history_detail[0].created_by_name + ' at ' + moment.utc(history_detail[0].book_created_date).tz(this.$store.state.timezone).format('hh:mm A'))
                    }

                    let history_update_date = moment.utc(history_detail[0].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                    if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_EARLY_CANCELLED)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_EARLY_CANCELLED);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_EARLY_CANCELLED) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }

                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are cancelled by ' + history_detail[serv_index].updated_by_name + ' at ' + moment(history_update_date).format('hh:mm A'))

                    }

                    if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_RESCHEDULED)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_RESCHEDULED);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_RESCHEDULED) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }
                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are Rescheduled by ' + history_detail[serv_index].updated_by_name + ' at ' + moment(history_update_date).format('hh:mm A'));

                    }

                    if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_ARRIVED)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_ARRIVED);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_ARRIVED) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }
                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are arrived at ' + moment(history_update_date).format('hh:mm A'))
                    } else if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_COMPLETED)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_COMPLETED);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_COMPLETED) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }
                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are completed at ' + moment(history_update_date).format('hh:mm A'));

                    } else if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_LATE_CANCELLED)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_LATE_CANCELLED);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_LATE_CANCELLED) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }
                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are late cancelled at ' + moment(history_update_date).format('hh:mm A'))
                    } else if (history_detail.some(book_history => book_history.book_status == this.Constants.STATUS_NO_SHOW)) {

                        let serv_index = history_detail.findIndex(history => history.book_status == this.Constants.STATUS_NO_SHOW);

                        history_update_date = moment.utc(history_detail[serv_index].book_updated_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                        if (!(history_update_date in this.bookings_history_display_object)) {
                            this.bookings_history_display_object[history_update_date] = []
                        }

                        let created_text = "";

                        history_detail.forEach(serv_history => {
                            if (serv_history.book_status == this.Constants.STATUS_NO_SHOW) {
                                if ('serv_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.serv_name : created_text + ', ' + serv_history.serv_name;
                                } else if ('product_name' in serv_history) {
                                    created_text = (created_text == "") ? serv_history.product_name : created_text + ', ' + serv_history.product_name;
                                }
                            }
                        })

                        this.bookings_history_display_object[history_update_date].push(created_text + ' are late cancelled at ' + moment(history_update_date).format('hh:mm A'))
                    }


                    if (history_detail.some(book_history => Object.keys(book_history).includes('book_trans_created_date'))) {

                        let payment_type_group = history_detail.reduce((r, a) => {
                            r[a.book_trans_gateway_method] = [...r[a.book_trans_gateway_method] || [], a];
                            return r;
                        }, {});

                        for (let [payment_type, pay_type_history] of Object.entries(payment_type_group)) {

                            let serv_trans_date = moment.utc(pay_type_history[0].book_trans_created_date).tz(this.$store.state.timezone).format('YYYY-MM-DD HH:mm:ss');

                            if (!(serv_trans_date in this.bookings_history_display_object)) {
                                this.bookings_history_display_object[serv_trans_date] = []
                            }

                            let paid_type = 'cash';

                            if (payment_type == 0) {
                                paid_type = 'cash';
                            } else if (payment_type == 1) {
                                paid_type = 'stripe';
                            } else if (payment_type == 2) {
                                paid_type = 'paypal';
                            } else if (payment_type == 3) {
                                paid_type = 'afterpay';
                            } else if (payment_type == 4) {
                                paid_type = 'wallet';
                            } else if (payment_type == 5) {
                                paid_type = 'Point Of Sale';
                            } else if (payment_type == 6) {
                                paid_type = 'square';
                            }

                            let amount_paid = 0;
                            pay_type_history.forEach(type_history => {
                                amount_paid += type_history.book_trans_paid_now;
                            })

                            if (amount_paid > 0) {
                                this.bookings_history_display_object[serv_trans_date].push('Amount of $' + amount_paid.toFixed(2) + ' has been received via ' + paid_type + ' at ' + moment(serv_trans_date).format('hh:mm A'))
                            }

                        }

                    }
                }

                this.bookings_history_display_object = Object.keys(this.bookings_history_display_object).sort().reduce(
                    (obj, key) => {
                        obj[key] = this.bookings_history_display_object[key];
                        return obj;
                    }, {}
                );

                for (let [date, date_history] of Object.entries(this.bookings_history_display_object)) {
                    if (date_history.length == 0) {
                        delete this.bookings_history_display_object[date];
                    }
                }

                let book_time_history = {};

                for (let [total_date, date_time_history] of Object.entries(this.bookings_history_display_object)) {
                    let format_date = moment(total_date).format('ddd, DD MMM YYYY');

                    if (!(format_date in book_time_history)) {
                        book_time_history[format_date] = []
                    }

                    date_time_history.forEach(data_history => {
                        book_time_history[format_date].push(data_history);
                    })

                }

                this.bookings_history_display_object = book_time_history;

            }
        },

        rebook_date(weeks) {
            sessionStorage.setItem('session_calendar_initial_view', 'resourceTimeGridDay');
            this.send_events_to_clipboard(this.Constants.CLIPBOARD_EVENT_FROM_REBOOK)
            this.$store.state.selected_date = moment(new Date(), 'dd-mm-yyyy').add(weeks * 7, "days").format('YYYY-MM-DD');
            this.$router.push('/calendar');
        },

        editbooking() {
            this.$session.set('booking_type', this.Constants.BOOKING_TYPE_EDIT_BOOKING);
            this.$session.set('editbooking', true);
            this.$router.push('/newbooking');
        },

        status_change(selected) {

            if (selected == this.Constants.STATUS_BOOKED) {
                this.$store.state.booked_popup = true;
            } else if (selected == this.Constants.STATUS_ARRIVED) {
                this.$store.state.arrived_popup = true;
            } else if (selected == this.Constants.STATUS_COMPLETED) {
                this.$store.state.completed_popup = true;
            } else if (selected == this.Constants.STATUS_NO_SHOW) {
                this.$store.state.noshow_popup = true;
            } else if (selected == this.Constants.STATUS_EARLY_CANCELLED) {
                this.$store.state.cancel_popup = true;
            } else if (selected == this.Constants.STATUS_LATE_CANCELLED) {
                this.$store.state.latecancel_popup = true;
            }
        },

        changeValue(type) {
            if (type == this.Constants.STATUS_BOOKED) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.booked_popup = false;
            } else if (type == this.Constants.STATUS_ARRIVED) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.arrived_popup = false;
            } else if (type == this.Constants.STATUS_COMPLETED) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.bookings_data_v2.bookings[0].book_status = type;
                this.$store.state.completed_popup = false;
            } else if (type == this.Constants.STATUS_NO_SHOW) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.bookings_data_v2.bookings[0].book_status = type;
                this.$store.state.noshow_popup = false;
            } else if (type == this.Constants.STATUS_EARLY_CANCELLED) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.bookings_data_v2.bookings[0].book_status = type;
                this.$store.state.cancel_popup = false;
            } else if (type == this.Constants.STATUS_LATE_CANCELLED) {
                this.$store.state.book_status = this.present_status = type
                this.$store.state.bookings_data_v2.bookings[0].book_status = type;
                this.$store.state.latecancel_popup = false;
            }
        },

        cancelStatusChange(type) {
            if (type == this.Constants.STATUS_BOOKED) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.booked_popup = false;
            } else if (type == this.Constants.STATUS_ARRIVED) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.arrived_popup = false;
            } else if (type == this.Constants.STATUS_COMPLETED) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.completed_popup = false;
            } else if (type == this.Constants.STATUS_NO_SHOW) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.noshow_popup = false;
            } else if (type == this.Constants.STATUS_EARLY_CANCELLED) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.cancel_popup = false;
            } else if (type == this.Constants.STATUS_LATE_CANCELLED) {
                this.present_status = this.$store.state.book_status;
                this.$store.state.latecancel_popup = false;
            }

            this.status_apply();
        },

        status_apply() {
            for (let j = 0; j < this.status.length; j++) {
                if (this.present_status == this.status[j].status_id) {
                    this.book_present_status = this.status[j];
                }
            }
        },

        reschedule_booking() {
            sessionStorage.setItem('session_calendar_initial_view', 'resourceTimeGridDay');
            this.send_events_to_clipboard(this.Constants.CLIPBOARD_EVENT_FROM_RESCHEDULE)
            this.$router.push("/calendar");
        },

        send_events_to_clipboard(from) {
            var get_services = this.services_data;
            var get_customers = this.get_customers.customer_details[0]
            for (let service = 0; service < get_services.length; service++) {
                var event_data = {
                    id: get_services[service].book_id.toString(),
                    date: get_services[service].book_start_date,
                    vip: get_customers.is_vip,
                    allergy: get_customers.has_allergy,
                    fullpayment: get_customers.pay_fullpayment,
                    banned: get_customers.is_banned,
                    book_status: this.book_present_status.status_id,
                    name: get_customers.cust_first_name + ' ' + get_customers.cust_last_name,
                    start_time: get_services[service].book_start_time,
                    end_time: get_services[service].book_end_time,
                    service: get_services[service].serv_name,
                    booking_notes: get_services[service].book_staff_note,
                    last_visit_count: get_services[service].last_visited.length,
                    clipboard_event_flag: from
                }
                ClipboardEventsJS.create_clipboard_event(event_data)
            }
        },

        update_booking_notes() {
            this.$refs.booking_staff_note_ref.innerText = 'Saving..';
            if ((this.$session.get('book_id')) != '' && (this.$session.get('book_id')) != undefined) {
                axios.post(this.$store.state.api + 'booking/update_booking_notes', {
                    "book_id": this.$session.get('book_id'),
                    "book_notes": this.services_data[0].book_staff_note,
                    'multi_service_book_id': this.$session.get('multi_book_id')
                }).then(result => {
                    if (result.status == 200) {
                        this.$refs.booking_staff_note_ref.innerText = 'Saved';
                        this.$refs.booking_staff_note_ref.style.cssText = "background: #10A377 !important";
                        this.booking_staff_note_show_update_status();
                    }
                }, error => {
                    console.log(error)
                    this.$refs.booking_staff_note_ref.innerText = 'Failed';
                    this.booking_staff_note_show_update_status();
                })
            }
        },

        booking_staff_note_show_update_status() {
            let _this = this;
            setTimeout(function() {
                _this.booking_staff_note = false;
                _this.$refs.booking_staff_note_ref.style.cssText = "";
                _this.$refs.booking_staff_note_ref.innerText = 'Save';
            }, 700);
        },

        async update_customer_notes() {
            let cust_details = this.$store.state.customer_data.customer_details;
            await this.$store.dispatch('update_customer_notes', [this.$store.state.api, cust_details[0].cust_id, this.$store.state.user_id, cust_details[0].cust_notes, this.$store.state.user_id])
            if (cust_details[0].cust_notes.length != 0) {
                this.$refs.edit_cust_notes[0].innerHTML = 'Saved';
                this.$refs.edit_cust_notes[0].style.cssText = "background: #10A377 !important";
            }
            this.save_cust_notes();
        },

        edit_cust_notes() {
            this.edit_customer_notes = true;
            let _this = this;
            setTimeout(function() {
                _this.$refs.cust_notes[0].focus();
            }, 100);
        },

        save_cust_notes() {
            let _this = this;
            setTimeout(function() {
                _this.edit_customer_notes = false;
            }, 700);

        },

        openImageModel(show_upload) {
            var get_customers = this.get_customers.customer_details[0]
            this.imageBookingId = this.$session.get('book_id');
            this.imagePopupName = get_customers.cust_first_name + ' ' + get_customers.cust_last_name;
            this.imageMultiBookId = this.$session.get('multi_book_id');
            this.show_upload_picture = show_upload;
            this.service_image_crop_model = true;
        },

        go_to_payment() {
            var payment_details = {
                "cust_id": this.get_customers.customer_details[0].cust_id,
                "book_id": this.$session.get('book_id'),
                "multi_book_id": this.$session.get('multi_book_id')
            }
            this.$session.set('payment_details', payment_details);
            this.$session.set('toast_title', 'Payment Successful');
            this.$router.push('/payment');
        },

        go_to_calender() {
            this.$router.push('/calendar');
        },

        go_to_invoice() {
            this.$router.push('/invoice');
        },
        async showUrl(form_url, form_filled) {
            if (form_filled) {
                window.open(form_url)
            } else {
                this.$store.state.loader_popup = true;
                let cust_email = this.get_customers.customer_details[0].cust_email;
                try {
                    await this.$store.dispatch('send_form_url', [this.$store.state.api, cust_email, form_url]);
                    this.$bvToast.toast(`Form link sent to customer email successfully`, {
                        title: `Success`,
                        variant: 'success',
                        autoHideDelay: 5500,
                        solid: true
                    });
                    this.$store.state.loader_popup = false;
                } catch (error) {
                    this.$bvToast.toast(`Something Went Wrong`, {
                        title: `Fail`,
                        variant: 'warning',
                        autoHideDelay: 5500,
                        solid: true
                    });
                    this.$store.state.loader_popup = false;
                }
            }
        }
    },
    filters: {
        human_date_format: function(date, timezone, date_format) {
            return utils.human_date_format(date, timezone, date_format)
        },

        time_12hrs_format: function(time, time_format) {
            return utils.time_12hrs_format(time, time_format)
        },
        uppercase: function(name) {
            if (name) {
                return name.toUpperCase();
            }

        }

    }
}